export default class collectDialogCtrl {
  constructor(
    $scope,
    $uibModalInstance,
    httpRequest,
    logger,
    items1,
    orgId,
    orgList,
    sweetalert
  ) {
    $scope.currentOrgId = orgId
    const currentRoutAddress = JSON.parse(
      sessionStorage.getItem('currentRoutAddress')
    )
    const userInfo = JSON.parse(localStorage.user_info)
    $scope.sale = userInfo.sale
    //获取当前税号的进项是否是电子税局，true 电子税
    httpRequest.get_getIsElecTaxBureau().then(res => {
        $scope.isElecTaxBureau = res.data.value
        httpRequest.get_getSaleInfoSys($scope.sale.saleId).then((res) => {
            $scope.isGLPT = res.data.value.ivatCollectServer.diskType == 3 ? true : false
            $scope.param = {
                reqBeginTime: '',
                displayStart: 0,
                reqEndTime: '',
                displayLength: $scope.isElecTaxBureau?500:1000,
                reqAuthStatus: '0',
                reqTaxPeriod: '',
                isGLPT: $scope.isGLPT,
                // diskPassword: '',
            }
            console.log(items1)
            if($scope.isGLPT){
                $scope.authStatusList = items1.filter((item) => item.enumCode !== '3' )
            }else {
                $scope.authStatusList = items1
            }
            get_qryOrgTaxPeriod(orgId)
        })
    })
    let current = ''
    // 查询当前所属期 设置默认值
    function get_qryOrgTaxPeriod(orgId) {
      $scope.param.orgIdCollect = orgId
      httpRequest.get_qryOrgTaxPeriod(orgId).then((res) => {
        if (res.data.success) {
          current = res.data.value.periodCode
          const periodCode = parseInt(current, 10)
          const year = (periodCode / 100).toFixed(0)
          let month = periodCode % 100
          const now = new Date()
          if (month > now.getMonth()) {
            now.setFullYear(year)
            now.setMonth(month)
            now.setDate(0)
          }
          const isLeap =
            (year % 4 === 0 && year % 100 === 0) || year % 400 === 0
          const monthArr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
          if (isLeap) {
            monthArr[1] = 29
          }
          const date = monthArr[month - 1]
          if (month <= 9) {
            month = `0${month}`
          }

          $scope.param.reqTaxPeriod = `${year}-${month}`
          $scope.param.reqBeginTime = `${year}-${month}-01`
          $scope.param.reqEndTime = `${year}-${month}-${date}`
        } else {
          $scope.param.reqBeginTime = ''
          $scope.param.reqEndTime = ''
        }
      })
    }
    //机构树的check配置信息
    $scope.config = {
      check: {
        enable: true, //显示不显示复选框
        chkboxType: { Y: '', N: '' },
        chkStyle: 'radio',
        radioType: 'all',
      },
    }
    $scope.orgList = orgList
    // 机构勾选变化
    $scope.orgIdListArr = []
    angular.forEach($scope.orgList, function (item, index) {
      item.checked = false
      // 默认勾选当前机构
      if (item.orgId === orgId) {
        item.checked = true
        $scope.orgIdListArr.push(item.orgId)
        // 默认显示当前机构
        $scope.selectedOrgList = [item]
      }
    })
    // 所选择的机构名称
    $scope.handleOrgChange = function (orgData) {
      if (orgData.length > 0) {
        angular.forEach(orgData, function (item, index) {
          $scope.orgIdListArr.push(item.orgId)
          $scope.currentOrgId = item.orgId
          $scope.param.orgIdCollect = $scope.currentOrgId
          get_qryOrgTaxPeriod(item.orgId)
          $scope.menuPermissions($scope.currentOrgId)
        })
      } else {
        $scope.param.orgIdCollect = ''
      }
    }
    // 获取当前登陆用户的菜单权限
    $scope.menuPermissions = function (currentOrgId) {
      httpRequest
        .post_getFunctionListByUserAndOrgIds([currentOrgId])
        .then((res) => {
          $scope.allMenuPermissions = res.data.value
        })
    }
    $scope.menuPermissions($scope.currentOrgId)
    // 权限控制
    $scope.hasPermitHandle = function (currentOrgId, hasPermit) {
      // 默认 false
      $scope.hasPermitFlag = false
      if (!$scope.allMenuPermissions || $scope.allMenuPermissions.length == 0) {
        return $scope.hasPermitFlag
      }
      // 对应菜单数据权限
      $scope.CurrMenuPermiss = $scope.allMenuPermissions.filter((item) => {
        return item.orgId == currentOrgId
      })
      functionListChild(
        $scope.CurrMenuPermiss[0].functionList,
        currentRoutAddress,
        hasPermit,
        (item, currentRout, hasPermit) => {
          if (item.url == currentRout) {
            // console.log('存在路由')
            return true
          } else if (item.functionCode == hasPermit) {
            // console.log('存在对应权限')
            $scope.hasPermitFlag = true
            return false
          }
          return false
        }
      )
      return $scope.hasPermitFlag
    }
    // 校验是否有权限
    let functionListChild = function (
      functionList,
      currentRout,
      hasPermit,
      cb
    ) {
      for (const i in functionList) {
        let flat = cb(functionList[i], currentRout, hasPermit)
        if (functionList[i].childFuncList && flat) {
          functionListChild(
            functionList[i].childFuncList,
            currentRout,
            hasPermit,
            cb
          )
        }
      }
    }
    // let startDate = new Date()
    // startDate.setDate(startDate.getDate() - 360)

    // 开票日期 日期控件设置 360天之前
    $scope.invoiceDatepickerConfig = {
      // startDate,
      endDate: new Date(),
      forceParse: true,
    }
    // let startDate = new Date()
    // startDate.setFullYear(startDate.getFullYear() - 1)
    // 所属期日期控件设置 查一年
    $scope.datePickerConfig = {
      // startDate,
      endDate: new Date(),
      format: 'yyyy-mm',
      startView: 'year',
      minView: 'year',
    }

    // $scope.$watch('param.diskPassword', (newVal, oldVal) => {
    //     if (new RegExp(/^[0-9a-zA-Z]*$/g).test($scope.param.diskPassword)) return
    //     $scope.param.diskPassword = oldVal
    // })
    httpRequest.get_checkCollectConfigure().then((res) => {
      $scope.localOrRemote = res.data.localOrRemote
    })
    $scope.cancel = function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    $scope.ok = function ok() {
      if (
        ($scope.param.reqAuthStatus == '0' || $scope.isGLPT) &&
        (!$scope.param.reqBeginTime || !$scope.param.reqEndTime)
      ) {
        logger.logError('请选择开票时间')
        return
      }
      if ($scope.param.reqAuthStatus != '0' && !$scope.isGLPT) {
        $scope.param.reqBeginTime = ''
        $scope.param.reqEndTime = ''
        $scope.param.checkFlag = $scope.param.reqAuthStatus
        $scope.param.reqAuthStatus = 10
        if (!$scope.param.reqTaxPeriod) {
          logger.logError('请选择所属期')
          return
        }
      }
      if ($scope.param.orgIdCollect === '') {
        logger.logError('请选择机构名称')
        return
      }
      if (
        !$scope.hasPermitHandle($scope.currentOrgId, 'original_account_collect')
      ) {
        logger.logError('所选的机构没有采集权限，请检查！')
        return
      }
      // if ($scope.localOrRemote == 'local' && !$scope.param.diskPassword) {
      //     logger.logError('请填写证书口令')
      //     return
      // }
      $scope.param.reqTaxPeriod = $scope.param.reqTaxPeriod.replace('-', '')
      if (
        $scope.param.reqAuthStatus != '0' && !$scope.isGLPT &&
        current > $scope.param.reqTaxPeriod &&
        $scope.param.checkFlag !== '3'
      ) {
        sweetalert
          .confirm(
            '操作提醒',
            '当选择所属期为以前月份时，将同时采集抵扣与不抵扣发票'
          )
          .then(
            () => {
              $uibModalInstance.close($scope.param)
            },
            () => {
              $scope.param.reqAuthStatus = $scope.param.checkFlag
            }
          )
      } else {
        $uibModalInstance.close($scope.param)
      }
    }
  }
}
collectDialogCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'httpRequest',
  'logger',
  'items1',
  'orgId',
  'orgList',
  'sweetalert',
]



// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/originalAccount/collectDialogCtrl.js